import { NxCardModule } from "@allianz/ng-aquila/card";
import { NxCopytextModule } from "@allianz/ng-aquila/copytext";
import { NxDataDisplayModule } from "@allianz/ng-aquila/data-display";
import { NxGridModule } from "@allianz/ng-aquila/grid";
import { NxHeadlineModule } from "@allianz/ng-aquila/headline";
import { NxIconModule } from "@allianz/ng-aquila/icon";
import { AllianzIconModule } from "@allianz/ngx-brand-kit/icon";
import { CommonModule } from "@angular/common";
import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CONSTANTS } from "@shared/enums/index.enum";
import { LayoutBreakPointsService } from "@shared/services/layout-break-points.service";
import moment from "moment";

@Component({
  selector: "app-campaign-card",
  templateUrl: "./campaign-card.component.html",
  styleUrls: ["./campaign-card.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    NxCardModule,
    NxCopytextModule,
    NxDataDisplayModule,
    NxGridModule,
    NxHeadlineModule,
    NxIconModule,
    AllianzIconModule,
  ],
})
export class CampaignCardComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Input() public data;
  @Input() public index;
  @Input() public expandIndex;
  @Output() public emitIndex = new EventEmitter();

  private viewDetails: boolean = false;
  private desktopView: boolean = false;

  constructor(
    private readonly layoutBreakpointService: LayoutBreakPointsService,
  ) {}

  ngOnInit(): void {
    this.layoutBreakpointService
      .subscribeLayoutChanges()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.desktopView = this.layoutBreakpointService.renderDesktop();
      });
  }

  private viewDetail(): void {
    if (this.data.groupList || this.data.groupList.length > 0) {
      this.viewDetails = !this.viewDetails;
      this.emitIndex.emit(this.index);
    }
  }

  protected formatDate(date: Date, format: string): string {
    return moment(date, CONSTANTS.YYYY_MM_DD_HH_MM_A).format(format);
  }

  //Roland - fix the warnings caught by sonarQube later in a separate branch. That will be easier to manage.
  protected identifyMomVariance(value: string, columnTitle: string) {
    if (columnTitle.toLowerCase().includes("variance")) {
      if (
        (value.startsWith("(") && value.endsWith(")")) ||
        value.startsWith("-")
      ) {
        return "red-value";
      } else {
        return "green-value";
      }
    }
  }

  // LOGIC FOR CARD EXPANSION LENGTH (TO-BE-RESTRUCTURED)
  protected expandCard() {
    const adjacentCardIndex =
      this.index % 2 === 0 ? this.index + 1 : this.index - 1;
    const adjacentIndexFound = this.expandIndex.find(
      (index) => index === adjacentCardIndex,
    );
    const haveIndex = this.expandIndex.includes(this.index);
    const haveIndex2 = this.expandIndex.includes(adjacentIndexFound);

    if (!haveIndex && !haveIndex2) {
      return "expanded-view";
    }
    return haveIndex2 ? "expanded-view" : "non-expanded-view";
  }
  // LOGIC FOR CARD EXPANSION LENGTH (TO-BE-RESTRUCTURED)

  protected getIconName(categoryName: string) {
    const categoryNameInLowerCase = categoryName.toLocaleLowerCase();
    switch (categoryNameInLowerCase) {
      case "motor": {
        return "product-car-small";
      }
      case "non-motor plines": {
        return "product-umbrella-protection";
      }
      case "non-motor commercial": {
        return "product-truck";
      }
      case "others": {
        return "product-care-insurance";
      }
      default: {
        return;
      }
    }
  }

  protected getIconClass(categoryName: string) {
    const categoryNameInLowerCase = categoryName.toLocaleLowerCase();
    switch (categoryNameInLowerCase) {
      case "motor":
      case "non-motor commercial": {
        return "campaign_icon_car";
      }
      case "non-motor plines":
      case "others": {
        return "campaign_icon";
      }

      default: {
        return;
      }
    }
  }

  protected getIconText(categoryName: string) {
    const categoryNameInLowerCase = categoryName.toLocaleLowerCase();
    switch (categoryNameInLowerCase) {
      case "motor":
      case "non-motor commercial": {
        return "motor_icon_text";
      }
      case "non-motor plines":
      case "others": {
        return "fw-semi-bold";
      }
      default: {
        return;
      }
    }
  }

  protected formatYearValue(value: string): string {
    if (value.substring(4, 5) === "-") {
      return value.toString().replace(value.substring(4, 5), " ");
    }
    return value;
  }

  protected formatBracketValue(value: string): string {
    return value.toString().replace(")(", ") (");
  }
}
